import type { OpenApiGetJivoCredentialsResponseSuccess } from '../../api/schema';
import { getJivoRedirectStaticUri } from '../const';

export const getJivoOauthUrl = ({
    base_url: baseUrl,
    client_id: clientId,
    scopes,
    state_token,
}: Pick<OpenApiGetJivoCredentialsResponseSuccess, 'base_url' | 'client_id' | 'scopes' | 'state_token'>) => {
    const params = new URLSearchParams();

    params.set('response_type', 'code');
    params.set('client_id', clientId);
    params.set('redirect_uri', getJivoRedirectStaticUri());
    params.set('scope', (scopes || []).join(' '));
    params.set('state', state_token);

    return `${baseUrl}/oauth2/authorize?${params.toString()}`;
};
